import { render } from "./MasterCard.vue?vue&type=template&id=2737701a"
import script from "./MasterCard.vue?vue&type=script&lang=js"
export * from "./MasterCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__